import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isFullZoomPath } from "@/lib/zoom";

// Toggles a full-size override on showcase pages (landing, login) so they render at 100%
// while the rest of the app honors the user's chosen interface zoom.
export default function ZoomManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const el = document.documentElement;
    if (isFullZoomPath(pathname)) el.setAttribute("data-zoom-full", "");
    else el.removeAttribute("data-zoom-full");
  }, [pathname]);
  return null;
}
